<div class="flex gap-2 align-items-start">
  <div [class]="'text-' + textSize + ' font-light text-700'">{{label}}</div>
  <div [class]="'text-' + textSize">{{value}}</div>
</div>
